export function getRangeWithDots(
  current: number,
  nrOfPages: number
): (number | string)[] {
  const pagesBeforeAndAfter = 2;
  const minPage = current - pagesBeforeAndAfter;
  const maxPage = current + pagesBeforeAndAfter + 1;
  const range = [];
  const completeRange = [];
  let l;

  if (nrOfPages > 9) {
    for (let i = 1; i <= nrOfPages; i++) {
      if (i === 1 || i === nrOfPages || (i >= minPage && i < maxPage)) {
        range.push(i);
      }
    }
  } else {
    for (let i = 1; i <= nrOfPages; i++) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        completeRange.push(l + 1);
      } else if (i - l !== 1) {
        completeRange.push("...");
      }
    }

    completeRange.push(i);
    l = i;
  }

  return completeRange;
}
